import { useEffect, useState } from "react";
import MemberCard from "../components/MemberCard";
import team from "../data/team.json";
import "../css/Team.css";

export default function Team() {
  useEffect(() => { document.title = "Team | Space Technology Students' Society"; }, []);
  let [contentCateg, setContentCateg] = useState(1);

  let categories = [
    [0, "Steering committee", "5th Years", "4th Years"],
    [1, "Governor and G-Sec", "Governors", "General Secretaries"],
    [2, "Executive Member", "Senior Executives", "Junior Executives"],
  ];

  const mapCategs = (categ) => {
    return (
      <div
        className={`team-page-cat ${
          contentCateg == categ[0] ? "team-page-cat-isactive" : ""
        }`}
        onClick={() => setContentCateg(categ[0])}
        key={categ[1]}
      >
        {categ[1]}
      </div>
    );
  };

  const renderSection = (label) => {
    const key = label.replace(/ /g, "-");
    const members = team[key];
    if (!members) return null;
    return (
      <>
        <div className="team-page-content-title">{label}</div>
        <div className="team-page-content-members">
          {members.map((data) => (
            <MemberCard
              data={data}
              isSpecial={contentCateg == 1}
              key={data.cardinal || data.name}
            />
          ))}
        </div>
      </>
    );
  };

  let content = (
    <>
      {renderSection(categories[contentCateg][2])}
      {categories[contentCateg][3] && renderSection(categories[contentCateg][3])}
    </>
  );

  return (
    <div className="team-page">
      <div className="team-page-header">
        <b>Our Team</b>
        <div className="team-page-cat-select">
          {categories.map((ele) => mapCategs(ele))}
        </div>
      </div>
      <div className="team-page-content">{content}</div>
    </div>
  );
}
